/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliEditInvitationEmailRequest } from '../../models/amoxcalli-edit-invitation-email-request';

export interface ApiInvitationsIdEmailPatch$Params {
  id: string;
      body?: AmoxcalliEditInvitationEmailRequest
}

export function apiInvitationsIdEmailPatch(http: HttpClient, rootUrl: string, params: ApiInvitationsIdEmailPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiInvitationsIdEmailPatch.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiInvitationsIdEmailPatch.PATH = '/api/invitations/{id}/email';
